export default "__VITE_ASSET__DmNAiqlm__"